import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  DESTINATION_GROUP,
  NAVIGATION_ORIGIN,
  NAVIGATION_TRIGGER_TYPE,
} from 'root/lib/SearchlightDispatcher';
import goToActivity from 'a/actions/navigationActions';
import { setFluencyVisited } from 'a/boostFluency/redux/actions';
import GameIds from 'a/hub/data/GameIds';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';
import { ModalContainer } from '../sharedComponents';
import WideBackground from '../svgs/Common/WideBackground.svg';
import {
  CloseModalButton,
  LargeBackground,
  DecolineUpper,
  DecolineLower,
  GoButton,
} from '../game/styledComponents';
import DecolineUpperIcon from '../game/svgs/DecolineUpper.svg';
import DecolineLowerIcon from '../game/svgs/DecolineLower.svg';
import GameIcon from '../../games/GameIcon';

const FLUENCY_ACTIVITIES = [
  { id: GameIds.BOOST_FLUENCY, displayName: 'Zephraya Broadcast' },
];

const FluencyLaunchModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const { playTap, playSfxFromMap, audioMap } = useWorkshopSfx();
  const clickedRef = useRef(false);
  const timeout = useRef(null);

  const [selectedActivityId, setSelectedActivityId] = useState(FLUENCY_ACTIVITIES[0].id);

  useEffect(() => {
    playSfxFromMap(audioMap.skill_game_launch);
    return () => clearTimeout(timeout.current);
  }, []);

  const onCloseButtonPress = () => {
    if (clickedRef.current) return;
    playTap(true);
    closeModal();
  };

  const onSelectActivity = (id) => {
    if (clickedRef.current) return;
    playTap(true);
    setSelectedActivityId(id);
  };

  const onGoButtonPress = () => {
    playTap();
    if (clickedRef.current) return;
    clickedRef.current = true;
    timeout.current = setTimeout(() => {
      dispatch(setFluencyVisited(true));
      dispatch(goToActivity({
        activityName: selectedActivityId,
        isQuestWorkflow: true,
        navigationParams: {
          origin: NAVIGATION_ORIGIN.WORKSHOP,
          destinationGroup: DESTINATION_GROUP.FLUENCY,
          trigger: 'fluencyModalGo',
          triggerType: NAVIGATION_TRIGGER_TYPE.MANUAL,
        },
      }));
      closeModal();
    }, 150);
  };

  return (
    <StyledContainer
      role="dialog"
      aria-modal="true"
      aria-labelledby="fluency-launch-modal-title"
      data-dd-action-name="fluency-launch-modal"
    >
      <CloseModalButton
        onClick={onCloseButtonPress}
        data-testid="fluency-launch-modal-close-button"
        data-dd-action-name="fluency-launch-modal:close"
      />
      <LargeBackground src={WideBackground} alt="" />
      <FluencyHeader id="fluency-launch-modal-title">· Fluency ·</FluencyHeader>
      <DecolineUpper src={DecolineUpperIcon} alt="" />
      <DecolineLower src={DecolineLowerIcon} alt="" />
      {FLUENCY_ACTIVITIES.map(({ id, displayName }) => (
        <StyledIconWrapper key={id}>
          <GameIcon
            game={{
              canonicalName: id,
              displayName,
              skillId: id,
            }}
            onSelectGame={() => onSelectActivity(id)}
            completed={false}
            isStarted={false}
            selectedGameSkillId={selectedActivityId}
            actionName={`fluency-launch-modal:${id}`}
          />
        </StyledIconWrapper>
      ))}
      <GoButton
        ariaLabel="Launch Fluency Activity"
        disabled={selectedActivityId === null}
        onClick={onGoButtonPress}
        actionName="fluency-launch-modal:go"
      />
    </StyledContainer>
  );
};

FluencyLaunchModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default FluencyLaunchModal;

const FluencyHeader = styled.h2`
  position: absolute;
  top: 81px;
  left: 450px;
  width: 124px;
  height: 40px;
  font-family: 'Quicksand';
  font-weight: 700;
  font-size: 27px;
  line-height: 100%;
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledContainer = styled(ModalContainer)`
  height: 558px;
`;

const StyledIconWrapper = styled.div`
  width: 180px;
  height: 180px;
`;
